export interface ArticuloSerial {
  idArticuloSerial: number;
  numeroSerial: string;
  idArticulo: number;
  idDeposito?: number | null;
  idLote?: number | null;
  estado: string; // DIS=Disponible, ASI=Asignado, SAL=Salida
  fechaIngreso?: string | null;
  fechaSalida?: string | null;
  observaciones?: string;
  articuloCodigo?: string;
  articuloDescripcion?: string;
  depositoNombre?: string;
  loteNumero?: string;
}

export const initialSerialState: ArticuloSerial = {
  idArticuloSerial: 0,
  numeroSerial: '',
  idArticulo: 0,
  estado: 'DIS',
};
